document.addEventListener('DOMContentLoaded', function () {
  // メインスライダー
  $('.js-main-slider').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000, 
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // 一緒に購入されている商品スライダー
  $('.js-bought-together-slider').slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});
